import axios from 'axios';
import { BASE_URL } from './api';

const API_URL = `${BASE_URL}/api/resume`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

// Get all resumes for logged-in user
export const getAllResumes = async () => {
  const response = await axios.get(API_URL, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Get single resume by ID
export const getResumeById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Create new resume
export const createResume = async (resumeData) => {
  const response = await axios.post(API_URL, resumeData, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Update resume
export const updateResume = async (id, resumeData) => {
  const response = await axios.put(`${API_URL}/${id}`, resumeData, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Delete resume
export const deleteResume = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Duplicate resume
export const duplicateResume = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/duplicate`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Set primary resume
export const setPrimaryResume = async (id) => {
  const response = await axios.patch(`${API_URL}/${id}/set-primary`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Get resume statistics
export const getResumeStats = async () => {
  const response = await axios.get(`${API_URL}/stats/overview`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Download resume as PDF
export const downloadResumePDF = async (id, templateId) => {
  const response = await axios.get(`${API_URL}/${id}/pdf`, {
    headers: getAuthHeader(),
    params: { templateId },
    responseType: 'blob'
  });
  return response.data;
};

// AI Prefill - Generate resume data using AI
export const generateAIResume = async (userData) => {
  const response = await axios.post(`${API_URL}/ai/prefill`, userData, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Generate ATS Score and Analysis
export const generateATSAnalysis = async (id) => {
  const response = await axios.post(`${API_URL}/${id}/ats-analysis`, {}, {
    headers: getAuthHeader()
  });
  return response.data.analysis;
};

